import { render, staticRenderFns } from "./PartnerIcons.vue?vue&type=template&id=7f87fa15&scoped=true"
import script from "./PartnerIcons.vue?vue&type=script&lang=js"
export * from "./PartnerIcons.vue?vue&type=script&lang=js"
import style0 from "./PartnerIcons.vue?vue&type=style&index=0&id=7f87fa15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f87fa15",
  null
  
)

export default component.exports